import {Record} from 'immutable';

export default class Font extends Record({
  category: '',
  displayName: '',
  extension: '',
  format: '',
  heightOffset: 0,
  latestVersion: '',
  minSize: 0,
  name: '',
  strokeType: '',
  supportsOutline: true
}) {
  constructor(fontCategory) {
    const {strokeType, ...args} = fontCategory;
    super(
      {
        ...args,
        strokeType,
        supportsOutline: !/\b(no|thin)\b/i.test(strokeType)
      },
      'FontCategory'
    );
  }
}
